<script>
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { ModelListSelect } from "vue-search-select";
import { mapActions, mapGetters, mapState } from "vuex";
import Swal from "sweetalert2";
// import moment from "moment";
/**
 * Form Layouts component
 */
export default {
  page: {
    title: "Record Order",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { PageHeader, ModelListSelect, Loader, },
  data() {
    return {
      title: "Add to Cart",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Record Order",
          active: true,
        },
      ],
      selected: null,
      totalRows: 1,

      currentPage: 1,
      perPage: 1000,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",

      selected1: null,
      totalRows1: 1,

      currentPage1: 1,
      perPage1: 1000,
      filter1: null,
      todoFilter1: null,
      filterOn1: [],
      todofilterOn1: [],
      sortDesc1: false,
      modal_id1: "",

      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "identification",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          key: "inCart",
          sortable: true,
          label: "ITEMS",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "DATE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],

      existingItem: [],
      unitsArr: [],
      batchArr: [],
      unitName: '',
      customerdata: {
        category_id: 1,
        contact: "",
        name: ""
      },

      // Value from user input for adding position
      data: {
        quantity_taken: 0,
        product: "",
        unit: "",
        quantity: "",
        type: "",
        saletype: 1,
        description: "",
        batch: "",
      },

      labels: {
        instock: "",
        price: "",
        mapped_ingredient: "",
      },
      add: {
        id: "",
        quantity_taken: 0,
        product: "",
        unit: "",
        quantity: "",
        instock: "",
        type: "",
        saletype: 1,
      },
      hold: {
        identification: "",
      },
      totals: {
        paid: "",
        total: "",
        customer: "",
        mode: "",
        discount: 0,
        sale_date: null,
        change: "",
        picking_date: "",
        staff: "",
        quotation_number: "",
        factory: "",
        document: 1
      },
      // edit item
      editdata: {
        id: "",
        name: "",
        type: "",
        product: "",
        base_qty: "",
        instock: "",
        quantity: "",
        quantity_taken: 0,
        unit_price: "",
      },
      // delete item
      deletedata: {
        name: "",
        id: "",
      },
      unhold: {
        id: "",
      },
      deleteholddata: {
        id: "",
      },
      factorydata: {
        name: "",
        contact: "",
        location: ""
      },
      nameError: "",
      contactError: "",
      modeError: "",
      customerError: "",
      staffError: "",
      paidError: "",
      itemError: "",
      quantityError: "",
      qtyError: "",
      unitError: "",
      unit_priceError: "",
      quantity1Error: "",
      identificationError: "",
      FBatches: [],
      TotalInCart: 0,
      productnames: "",
      productcount: 0,
    };

  },

  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapState("sales", ["total_cart", "saleId"]),
    ...mapGetters("sales", ["Products"]),
    ...mapGetters("sales", [
      "SaleSaveStatus",
      "Cart",
      "TotalCart",
      "SaleHeld"
    ]),
    ...mapGetters("setting", ["PaymentOptions", "GeneralSettings", "ReceiptSettings", "BusinessSettings"]),
    ...mapGetters("customers", ["Customers", "SaveStatus"]),
    ...mapGetters("staff", ["DeliveryStaff"]),
    ...mapGetters("auth", ["name", "username", "MyUserPerm", "business", "branch"]),
    ...mapGetters("products", ["Batches"]),
    ...mapGetters("retailoutlets", ["RetailOutlets"]),
    ...mapGetters("factorystock", ["ProductionFactories", "FactoryProductionBatches"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "ITEM",
        },
        {
          key: "quantity_field",
          sortable: true,
          label: "QTY",
        },
        {
          key: "unit_price",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total_price",
          sortable: true,
          label: "TOTAL",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        }
      ];
      if (this.GeneralSettings.track_untake_orders == 1) {
        baseFields.splice(3, 0,
          {
            key: "quantity_taken",
            sortable: true,
            label: "QTY TAKEN",
          },
        );
      }
      return baseFields;
    },

    formattedFactories() {
      const factories = Array.isArray(this.ProductionFactories)
        ? this.ProductionFactories
        : Array.isArray(this.ProductionFactories?.data)
          ? this.ProductionFactories.data
          : []

      return [
        { id: '', name: 'Select Factory', location: '' },
        ...factories
      ].map(factory => ({
        ...factory,
        display_name: factory.location
          ? `${factory.name} - ${factory.location}`
          : factory.name
      }))
    },

    formattedProductionBatches() {
      const batches = Array.isArray(this.FactoryProductionBatches)
        ? this.FactoryProductionBatches
        : Array.isArray(this.FactoryProductionBatches?.data)
          ? this.FactoryProductionBatches.data
          : []

      return [
        { id: '', batch_no: 'Select Batch', date: '', input_quantity: '' },
        ...batches
      ].map(batch => ({
        ...batch,
        display_name: batch.input_quantity
          ? `${batch.batch_no ? batch.batch_no : batch.id} - ${batch.date} (INPUT-${batch.input_quantity})`
          : `${batch.batch_no}`
      }))
    },

    rows() {
      return this.Cart ? this.Cart.length : 1;
    },
  },

  mounted() {
    this.totalRows = this.Cart ? this.Cart.length : 1;
    this.focusProduct();
  },
  watch: {
    show(newValue) {
      if (newValue) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
    total_cart(newValue) {
      this.TotalInCart = (this.TotalCart);
      if (newValue && this.GeneralSettings) {
        if (this.GeneralSettings.set_total_as_paid == 1) {
          this.totals.paid = this.thousandSeprator(this.TotalInCart);
        }
        this.totals.total = this.thousandSeprator(this.TotalInCart);
      }
    },
    PaymentOptions(newValue) {
      if (newValue) {
        this.setDefaultMode();
      }
    },
    saleId(newValue) {
      if (newValue && this.ReceiptSettings.print_receipt_after_sale == 1) {
        if (this.totals.document == 1) {
          if (this.ReceiptSettings.receipt_type == 1) {
            window.open(
              `https://${window.location.host}/receipts/salesreceipt.php?id=${btoa(newValue)}`
            );
          } else if (this.ReceiptSettings.receipt_type == 2) {
            window.open(
              `https://${window.location.host}/receipts/salesreceiptv2.php?id=${btoa(newValue)}`
            );
          } else if (this.ReceiptSettings.receipt_type == 3) {
            window.open(
              `https://${window.location.host}/receipts/salesreceiptv3.php?id=${btoa(newValue)}`
            );
          } else if (this.ReceiptSettings.receipt_type == 4) {
            window.open(
              `https://${window.location.host}/receipts/salesreceiptv4.php?id=${btoa(newValue)}`
            );
          } else if (this.ReceiptSettings.receipt_type == 5) {
            window.open(
              `https://${window.location.host}/receipts/deliverynote.php?id=${btoa(newValue)}`
            );
          } else {
            window.open(
              `https://${window.location.host}/receipts/salesreceipt.php?id=${btoa(newValue)}`
            );
          }
        } else if (this.totals.document == 2) {
          window.open(
            `https://${window.location.host}/receipts/invoice.php?id=${btoa(newValue)}`
          );
        } else if (this.totals.document == 3) {
          window.open(
            `https://${window.location.host}/receipts/deliverynote.php?id=${btoa(newValue)}`
          );
        }
      }
    },

    GeneralSettings(newValue) {
      if (newValue.show_batch_selling == 1) {
        this.FetchBatches();
      }
      if (newValue.multiple_factories == 1) {
        this.FetchProductionFactories();
      }
    },

    // Fetch sale data
    Cart(newValue) {
      if (newValue) {
        this.totals.customer = newValue[0]?.customer_id || "";
        this.totals.discount = newValue[0]?.discount || 0;
        this.totals.sale_date = newValue[0]?.date || "";
        this.totals.quotation_number = newValue[0]?.quotation_number || "";
      }
    }
  },
  methods: {
    ...mapActions({
      FetchCart: "sales/fetchCart",
      FetchHold: "sales/fetchHeld",
      FetchProducts: "sales/fetchItems",
      FetchCustomers: "customers/fetchCustomers",
      FetchStaff: "staff/fetchStaff",
      AddCart: "sales/addToCart",
      AddCart1: "sales/addToCart1",
      DeleteCartItem: "sales/deleteCart",
      FetchTotal: "sales/fetchTotCart",
      EditCartItems: "sales/editCart",
      SaveSalePrint: "sales/saveSalePrint",
      SaveSaleExit: "sales/saveSaleExit",
      Hold: "sales/holdSale",
      UnHold: "sales/unHoldSale",
      AddOrder: "sales/addHold",
      DeleteHold: "sales/deleteHold",
      FetchModes: "setting/fetchPaymentOptions",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      fetchReceiptSettings: "setting/fetchReceiptSettings",
      AddCustomer: "customers/addCustomer",
      LogOut: "auth/logout",
      FetchBatches: "products/fetchBatches",
      FetchRetailOutlets: "retailoutlets/fetchRetailOutlets",
      FetchBusinessSettings: "setting/fetchBusinessSettings",
      FetchProductionFactories: "factorystock/fetchProductionFactories",
      FetchFactoryProductionBatches: "factorystock/fetchFactoryProductionBatches",
      AddProductionFactory: "production/addProductionFactory",
    }),
    // COMMA SEPERATORS
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/[^0-9.]+/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    // set comma separators
    paidCommas() {
      this.totals.paid = this.thousandSeprator(this.totals.paid);
    },
    discountCommas() {
      this.totals.discount = this.thousandSeprator(this.totals.discount);
    },
    buyingCommas() {
      this.data.unit_price = this.thousandSeprator(this.data.unit_price);
    },
    editBuyingCommas() {
      this.editdata.unit_price = this.thousandSeprator(this.editdata.unit_price);
    },

    updateQtyTkn() {
      this.data.quantity_taken = this.data.quantity;
    },
    setUntakenheldQty() {
      this.add.quantity_taken = this.add.quantity;
    },

    // Fetch product units
    assignArr() {
      let productID = this.data.product.split(' ')[0];
      let selectedPdt = this.Products.filter((product) => {
        return product.id == productID || product.code == this.data.product;
      })
      this.unitsArr = selectedPdt[0].units;
      this.unitName = selectedPdt[0].unitname;
      this.data.type = selectedPdt[0].type;
      this.data.unit = this.unitsArr[0].id;
      this.labels.instock = selectedPdt[0].instock;
      this.labels.mapped_ingredient = this.GeneralSettings.use_bill_of_materials == 1?selectedPdt[0].mapped_ingredient:'';
      this.labels.price = this.data.saletype == 1 ? selectedPdt[0].selling : selectedPdt[0].wholesale_unitprice;
    },

    assignArr2() {
      let selectedPdt = this.Products.filter((product) => {
        return product.id == this.add.product || product.code == this.add.product;
      })
      this.unitsArr = selectedPdt[0].units;
      this.add.type = selectedPdt[0].type;
      this.add.unit = this.unitsArr[0].id;
      this.add.instock = selectedPdt[0].instock;
    },

    // Fetch batches
    FetchBatch() {
      this.FBatches = this.Batches.filter((batch) => {
        return batch.product_id == this.data.product.split(' ')[0];
      })
    },

    // Validate quantity being submitted
    validateQty() {
      if (this.data.product && this.data.quantity && this.data.unit && this.data.type == 1) {
        let tot = this.unitsArr.filter((unit) => {
          return unit.id == this.data.unit;
        });
        let totEqv = tot[0].base_qty * this.data.quantity;
        if (this.GeneralSettings.allow_negative_stock == 0 && totEqv > this.labels.instock && !this.labels.mapped_ingredient) {
          this.quantityError = "Quantity Out Of Range";
          return;
        }
        else {
          this.quantityError = "";
        }
        if (this.data.quantity_taken > this.data.quantity) {
          this.quantityError = "Quantity Taken Out Of Range";
          return;
        }
        else {
          this.quantityError = "";
        }

      }
    },

    validateQty2() {
      if (this.add.product && this.add.quantity && this.add.unit && this.add.type == 1) {
        let tot = this.unitsArr.filter((unit) => {
          return unit.id == this.add.unit;
        });
        let totEqv = tot[0].base_qty * this.add.quantity;
        if (this.GeneralSettings.allow_negative_stock == 0 && totEqv > this.add.instock) {
          this.qtyError = "Quantity Out Of Range";
          return;
        }
        else {
          this.qtyError = "";
        }
      }
    },

    validateQty1() {
      if (this.editdata.product && this.editdata.quantity && this.editdata.type == 1) {
        let tot = this.editdata.quantity * this.editdata.base_qty;
        if (this.GeneralSettings.allow_negative_stock == 0 && tot > this.editdata.instock) {
          this.quantity1Error = "Quantity Out Of Range";
          return;
        }
        else {
          this.quantity1Error = "";
        }
      }
    },

    // Check to restric duplicate product records into cart.
    checkItem() {
      if (this.data.product != "" && this.data.unit != "") {
        let productID = this.data.product.split(' ')[0];
        let batchID = this.data.batch ? this.data.batch.split(' ')[0] : '';
        this.existingItem = this.Cart.filter((item) => {
          if (batchID) {
            return item.product_id == productID && item.unit_id == this.data.unit && item.batch ? item.batch.id == batchID : '' || item.code == this.data.product && item.unit_id == this.data.unit && item.batch ? item.batch.id == batchID : '';
          } else {
            return item.product_id == productID && item.unit_id == this.data.unit || item.code == this.data.product && item.unit_id == this.data.unit;
          }
        });
        if (this.existingItem.length) {
          this.itemError = "This Item already exists";
          return;
        } else {
          this.itemError = "";
        }
      } else {
        this.existingItem = [];
      }
    },

    setDefaultMode() {
      let defaultop = this.PaymentOptions ? this.PaymentOptions : [].filter((mode) => {
        return mode.default == 1;
      })
      this.totals.mode = defaultop[0] ? defaultop[0].id : 0;
    },

    // Reset data fields
    resetData() {
      this.data.quantity_taken = 0;
      this.data.product = "";
      this.data.unit = "";
      this.data.quantity = "";
      this.data.type = "";
      this.data.description = "";
      this.data.batch = "";
      this.labels.instock = "";
      this.labels.price = "";
    },

    resetDeleteItem() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetEdit() {
      this.resetErrors();
      this.editdata.name = "";
      this.editdata.id = "";
      this.editdata.product = "";
      this.editdata.type = 1;
      this.editdata.quantity = "";
      this.editdata.instock = "";
      this.editdata.base_qty = "";
      this.editdata.quantity_taken = 0;
      this.editdata.unit_price = "";
      this.modal_id = "";
    },

    resetHold() {
      this.hold.identification = "";
    },

    resetErrors() {
      this.nameError = "";
      this.contactError = "";
      this.qtyError = "";
      this.itemError = "";
      this.unitError = "";
      this.quantityError = "";
      this.quantity1Error = "";
      this.unit_priceError = "";
      this.modeError = "";
      this.paidError = "";
      this.identificationError = "";
      this.customerError = "";
      this.staffError = "";
    },

    resetTotals() {
      this.totals.total = 0;
      this.setDefaultMode();
      this.totals.paid = '';
      this.totals.discount = 0;
      this.totals.customer = "";
      this.totals.staff = "";
      this.totals.change = "";
      this.totals.picking_date = "";
    },

    resetCustomer() {
      this.customerdata.contact = "";
      this.customerdata.name = "";
    },

    resetAdd() {
      this.add.id = "";
      this.add.product = "";
      this.add.quantity = "";
      this.add.unit = "";
    },

    // Fetch to assign value on button clicks
    showEditModal(data) {
      this.editdata.product = data.product_id;
      this.editdata.name = data.name;
      this.editdata.id = data.id;
      this.editdata.type = data.type;
      this.editdata.base_qty = data.baseQty;
      this.editdata.instock = data.instock;
      this.editdata.quantity = data.quantity;
      this.editdata.quantity_taken = data.quantity_taken;
      this.editdata.unit_price = this.thousandSeprator(data.selling);
    },

    showDeleteModal(data) {
      this.deletedata.name = data.name;
      this.deletedata.id = data.id;
    },

    showAddModal(data) {
      this.add.id = data.id;
    },

    showUnHoldModal(data) {
      this.unhold.id = data.id;
    },

    showDeleteHoldModal(data) {
      this.deleteholddata.id = data.id;
    },

    // Edit cart
    editItem(modalId) {
      this.modal_id = modalId;
      if (this.editdata.quantity == "" || this.editdata.quantity == 0) {
        this.quantity1Error = "Quantity Sold is required";
        return
      }
      this.validateQty1();
      if (this.quantity1Error) {
        return;
      }
      this.EditCartItems(this.editdata);
      this.closeModal(modalId);
    },

    // Delete from cart
    deleteItem(modalId) {
      this.modal_id = modalId;
      this.DeleteCartItem(this.deletedata);
      this.closeModal(modalId);
      this.resetTotals();
    },

    // Save and Print
    saveSalePrint(Id) {
      this.totals.document = Id;
      this.productnames = "";
      this.productcount = 0;
      this.productdata = this.Cart.filter((item) => {
        if (item.selling < item.reserve) {
          this.productnames = this.productnames + ', ' + item.name;
          this.productcount = this.productcount + 1;
        }
      });
      if (this.productcount > 0 && this.GeneralSettings.allow_reserve_price == 1) {
        Swal.fire("Error!", this.productcount + ' Product(s) [' + this.productnames + '] have selling price lower than reserve price, please correct its price or disable reserve price tracking to continue', "error");
        return;
      } else {
        if (this.totals.mode == "") {
          this.modeError = "Payment Mode is required";
          return;
        } else {
          this.modeError = "";
        }
        let paid1 = this.totals.paid ? this.totals.paid.replaceAll(/,/g, '') : 0;
        let discount1 = this.totals.discount != 0 ? this.totals.discount.replaceAll(/,/g, '') : 0;
        let tt = parseFloat(paid1) + parseFloat(discount1);
        if (this.totals.customer == "" && (tt < this.totals.total)) {
          this.customerError = "Customer is required";
          return;
        } else {
          this.customerError = "";
        }
        if (this.totals.paid == "") {
          this.totals.paid = 0;
        }
        this.SaveSalePrint(this.totals);
        this.resetTotals()
      }
    },

    // Save and Exit
    saveSaleExit() {
      this.productnames = "";
      this.productcount = 0;
      this.productdata = this.Cart.filter((item) => {
        if (item.selling < item.reserve) {
          this.productnames = this.productnames + ', ' + item.name;
          this.productcount = this.productcount + 1;
        }
      });
      if (this.productcount > 0 && this.GeneralSettings.allow_reserve_price == 1) {
        Swal.fire("Error!", this.productcount + ' Product(s) [' + this.productnames + '] have selling price lower than reserve price, please correct its price or disable reserve price tracking to continue', "error");
        return;
      } else {
        if (this.totals.mode == "") {
          this.modeError = "Payment Mode is required";
          return;
        } else {
          this.modeError = "";
        }
        let paid1 = this.totals.paid ? this.totals.paid.replaceAll(/,/g, '') : 0;
        let discount1 = this.totals.discount ? this.totals.discount.replaceAll(/,/g, '') : 0;
        let tt = parseFloat(paid1) + parseFloat(discount1);
        if (this.totals.customer == "" && (tt < this.totals.total)) {
          this.customerError = "Customer is required";
          return;
        } else {
          this.customerError = "";
        }
        if (this.totals.paid == "") {
          this.totals.paid = 0;
        }

        this.SaveSaleExit(this.totals);
        this.resetTotals();
        this.focusProduct();
      }

    },

    // Show change or Customer balance
    showBalance() {
      let total1 = this.totals.total;
      let paid1 = this.totals.paid.replaceAll(/,/g, '');
      let discount1 = this.totals.discount != 0 ? this.totals.discount.replaceAll(/,/g, '') : 0;
      let ttp = parseFloat(paid1) + parseFloat(discount1);
      if (this.totals.paid && total1 >= ttp) {
        this.totals.change = "Balance : " + this.thousandSeprator(total1 - ttp);
      } else if (this.totals.paid && total1 < ttp) {
        this.totals.change = "Change : " + this.thousandSeprator(ttp - total1);

      }
      if (paid1 == '') {
        this.totals.change = "Balance : " + this.thousandSeprator(total1);

      }
    },

    // Hold sale
    holdSale(mod) {
      this.modal_id = mod;
      if (this.hold.identification == "") {
        this.identificationError = "Identification is required";
        return;
      }
      this.Hold(this.hold);
      this.focusProduct();

    },

    // Add to cart for active and held sales
    addToCart() {
      if (this.data.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.data.quantity == "" || this.data.quantity <= 0) {
        this.quantityError = "Quantity is required";
        return;
      } else {
        this.quantityError = "";
      }
      this.validateQty();
      if (this.quantityError.length) {
        return this.quantityError;
      } else {
        this.quantityError = "";
      }

      this.checkItem();
      this.data.product = this.data.product.split(' ')[0];
      this.data.batch = this.data.batch.split(' ')[0];
      this.AddCart(this.data);
      this.resetData();
      this.focusProduct();
    },

    addToCart1(model) {
      this.modal_id = model;
      if (this.add.product == "") {
        this.itemError = "Product is required";
        return;
      } else {
        this.itemError = "";
      }
      if (this.add.quantity == "" || this.add.quantity <= 0) {
        this.qtyError = "Quantity is required";
        return;
      } else {
        this.qtyError = "";
      }
      this.add.saletype = this.data.saletype;
      this.validateQty2();
      this.AddCart1(this.add);
      this.focusProduct();

    },

    UnHoldOrder(mod) {
      this.modal_id = mod;
      this.UnHold(this.unhold);
      this.focusProduct();
    },

    deleteHeldItem(mod) {
      this.modal_id = mod;
      this.DeleteHold(this.deleteholddata);
      this.focusProduct();
    },

    redirect(value) {
      this.$router.push(
        `/hold/print/${btoa(value)}`
      );
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
        this.resetData();
        this.resetAdd();
        this.resetCustomer();
        this.resetErrors();
        this.resetEdit();
        this.resetDeleteItem();
      });
    },

    resetModal() {
    },

    // Validate Customer records
    validateCustomer() {
      if (this.customerdata.name != "" && this.customerdata.contact != '') {
        let selCust = this.Customers.filter((item) => {
          return item.phone == parseInt(this.customerdata.contact);
        })
        let custCount = selCust.length;
        if (custCount > 0) {
          this.contactError = "Customer with contact " + this.customerdata.contact + "  already Exists";
        }
      } else if (this.customerdata.name != "" && this.customerdata.contact == '') {
        let selCust = this.Customers.filter((item) => {
          return (item.name).toLowerCase() == (this.customerdata.name).toLowerCase();
        })
        let custCount = selCust.length;
        if (custCount > 0) {
          this.contactError = "Customer with these details already Exists";
        }
      }
    },

    // Add Customer
    addCustomer(modalId) {
      this.modal_id = modalId;
      if (this.customerdata.name === "") {
        this.nameError = "Name field is required";
        return;
      } else {
        this.nameError = "";
      }

      this.validateCustomer()
      if (this.contactError != "") {
        return
      }

      this.AddCustomer(this.customerdata);
      this.totals.customer = this.Customers[0].name - this.Customers[0].contact;
      this.closeModal(modalId);
    },

    nextPlease() {
      document.getElementById('input2').focus();
    },

    nextBatch() {
      document.getElementById('input3').focus();
    },

    logoutUser() {
      this.LogOut();
    },

    focusProduct() {
      this.$refs.cartProduct.focus();
    },
    focusCartPaid() {
      this.$refs.cartPaid.focus();
    },

    // Check customer balance
    CheckBalance() {
      if (this.GeneralSettings.show_customer_balances == 1) {
        let Balance = this.Customers.filter((bal) => {
          return bal.id == this.totals.customer;
        })
        if (Balance[0]) {
          this.totals.change = "Balance : " + (Balance[0].balance).toLocaleString();
        } else {
          this.totals.change = "Balance : 0";
        }
      } else {
        return "";
      }
    },

    FetchProductionBatches() {
      if (this.GeneralSettings.attach_production_batch_on_sales == 1 && this.MyUserPerm.attach_production_batch_on_sales == 1) {
        this.FetchFactoryProductionBatches(this.totals)
      }
    },

    addFactory(modalId) {
      this.modal_id = modalId;
      if (this.factorydata.name === "") {
        this.nameError = "Name field is required";
        return;
      } else {
        this.nameError = "";
      }
      this.validateFactory()
      if (this.contactError != "") {
        return
      }
      this.AddProductionFactory(this.factorydata);
    },
  },
  created() {
    this.FetchGeneralSettings();
    this.setDefaultMode();
    this.fetchReceiptSettings();
    this.FetchCustomers();
    this.FetchStaff();
    this.FetchProducts();
    this.FetchCart();
    this.FetchHold();
    this.FetchTotal();
    this.FetchModes();
    this.FetchRetailOutlets();
    this.FetchBusinessSettings();
    this.focusProduct();
  },

  updated() {
    this.totals.total = this.TotalInCart;
  },
};
</script>

<template>
  <Layout>
    <div class="sales-header">

      <!-- LEFT -->
      <div class="left-section">
        <router-link to="/" class="back-btn">
          <i class="fa fa-arrow-left"></i>
          <span class="d-none d-md-inline">Back</span>
        </router-link>
      </div>

      <!-- CENTER -->
      <div class="center-section">

        <span v-if="GeneralSettings.show_businessname == 1" class="title-main">
          {{ business }}
        </span>

        <span v-if="GeneralSettings.show_branchname == 1 && branch" class="title-sub">
          <em v-if="GeneralSettings.show_businessname == 1"> - </em>
          {{ branch }}
        </span>

      </div>

      <!-- RIGHT -->
      <div class="right-section">

        <b-dropdown right toggle-class="user-toggle" menu-class="dropdown-modern">

          <!-- BUTTON -->
          <template v-slot:button-content>
            <div class="user-box">
              <img class="avatar" src="@/assets/images/users/user1.png" />

              <span class="username d-none d-md-inline">
                {{ name || "User" }}
              </span>

              <i class="bx bx-chevron-down"></i>
            </div>
          </template>

          <b-dropdown-divider></b-dropdown-divider>

          <b-dropdown-item class="logout" @click="logoutUser">
            <i class="bx bx-power-off me-2"></i>
            Logout
          </b-dropdown-item>

        </b-dropdown>

      </div>

    </div>
    <PageHeader :title="title" :items="items" class="px-5 mt-2" />
    <!-- Display is showing batch numbers on selling is enabled ends-->
    <div class="row px-5">
      <div class="col-md-8 mb-5">
        <div class="card">
          <div class="card-body">
            <!-- Give options to sell or wholesale or retail -->
            <div class="row" v-if="GeneralSettings.enable_wholeselling == 1">
              <div class="col-sm-5">
                <div class="form-group mb-3">
                  <select class="form-control" v-model="data.saletype">
                    <option value="1">Retail</option>
                    <option value="2">Wholesale</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-5">
                <div class="form-group mb-3">
                  <label style="font-size: 18px;">Select Item<span class="text-danger">*
                      <em class="text-primary h5" v-if="data.product != ''"> Price: {{
                        labels.price ? labels.price.toLocaleString() : 0 }}</em>
                    </span></label>
                  <input id="input1" class="form-control" style="font-size: 15px;" v-model="data.product"
                    ref="cartProduct" list="products" placeholder="Select item to sell"
                    @input="resetErrors(), assignArr()" @keyup.enter="nextPlease()" @keyup.esc="focusCartPaid()" />
                  <datalist id="products">
                    <option v-for="(pdt, p) in Products" :value="pdt.name1" :key="p">
                    </option>
                  </datalist>
                  <div class="text-primary h5" v-if="labels.instock > 0 || labels.instock == '0'">
                    <em>Quantity in stock: {{ labels.instock }}{{ unitName }}</em>
                  </div>
                  <div class="text-danger" v-if="itemError">
                    <em>{{ itemError }}</em>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group mb-3">
                  <label style="font-size: 18px;">Enter Qty<span class="text-danger">*</span></label>
                  <input id="input2" type="number" class="form-control" step="any" v-model="data.quantity"
                    @input="resetErrors(), updateQtyTkn()" @keyup.enter="addToCart()" @keyup.esc="focusCartPaid()"
                    placeholder="Enter Quantity" />
                  <div class="text-danger" v-if="quantityError">
                    <em>{{ quantityError }}</em>
                  </div>
                </div>
              </div>

              <div class="col-sm-2" v-if="GeneralSettings.track_untake_orders == 1">
                <div class="form-group mb-3">
                  <label style="font-size: 18px;">Enter Qty taken<span class="text-danger">*</span></label>
                  <input id="input2" type="number" class="form-control" step="any" v-model="data.quantity_taken"
                    placeholder="Enter Quantity taken" @keyup.enter="addToCart()" />
                </div>
              </div>

              <div class="col-sm-3" v-if="GeneralSettings.allow_multiple_units == 1">
                <div class="form-group mb-3">
                  <label style="font-size: 18px;">Select Unit <span class="text-danger">*</span></label>
                  <model-list-select :list="unitsArr ? unitsArr : []" v-model="data.unit" option-value="id"
                    option-text="unitsym" placeholder="Unit" style="font-size: 15px;"
                    @input="resetErrors(), checkItem()" @keyup.enter="addToCart()">
                  </model-list-select>
                  <div class="text-danger" v-if="unitError">
                    <em>{{ unitError }}</em>
                  </div>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group mb-3">
                  <br />
                  <button class="btn btn-secondary  mt-2" @click="addToCart()" v-if="SaleSaveStatus">
                    <i class="fa fa-plus"></i> Add
                    <b-spinner variant="light" small label="Spinning"></b-spinner></button>
                  <button class="btn btn-secondary  mt-2" @click="addToCart()" v-else>
                    <i class="fa fa-plus"></i> Add </button>
                </div>
              </div>
            </div>

            <div class="row" v-if="GeneralSettings.sale_description == 1">
              <div class="form-group mb-3">
                <label>Description</label>
                <textarea @keyup.enter="addToCart()" type="text" class="form-control" v-model="data.description"
                  cols="30" rows="5"></textarea>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table class="datatables" style="font-size: 16px;" :items="Cart ? Cart : []" :fields="fields"
                responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-desc.sync="sortDesc"
                :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(total_price)="data">
                  {{
                    data.item.selling
                      ? thousandSeprator(data.item.selling * data.item.quantity)
                      : 0
                  }}
                </template>

                <template #cell(unit_price)="data">
                  {{ data.item.selling ? thousandSeprator(data.item.selling) : 0 }}
                </template>
                <template #cell(quantity_field)="data">
                  {{ data.item ? data.item.quantity : 0 }} {{ data.item ? data.item.unit : 0 }}
                </template>

                <template #cell(quantity_taken)="data">
                  {{ data.item ? data.item.quantity_taken : 0 }} {{ data.item ? data.item.unit : 0 }}
                </template>

                <template #cell(actions)="data">
                  <b-button size="sm" variant="primary" v-b-modal.edit-item-modal class="m-2"
                    @click="showEditModal(data.item)"><i class="fa fa-edit"></i></b-button>
                  <b-button v-b-modal.delete-item-modal variant="danger" size="sm"
                    @click="showDeleteModal(data.item)"><i class="fa fa-trash"></i></b-button>
                </template>
              </b-table>

            </div>
            <Loader v-if="!Cart" />
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <form action="">
              <div class="row" v-if="TotalInCart > 0">
                <div class="col-12 text-center">
                  <h4 style="font-size: 30px;">
                    <strong>TOTAL:
                      {{
                        TotalInCart ? thousandSeprator(TotalInCart) : 0
                      }}/=</strong>
                  </h4>
                </div>
              </div>
              <div class="form-group mb-2">
                <label style="font-size: 20px;">Enter Amount Received</label>
                <input type="text" ref="cartPaid" style="font-size: 20px;" class="form-control" v-model="totals.paid"
                  @input="paidCommas(), resetErrors(), showBalance()" @keyup.esc="focusProduct()"
                  @keyup.page-down="saveSalePrint()" @keyup.page-up="saveSaleExit()" min="0" />
              </div>
              <div class="text-primary h5" v-if="totals.change">
                <em>{{ totals.change }}</em>
              </div>
              <div class="form-group mb-2">
                <label style="font-size: 20px;">Select Payment Channel<span class="text-danger">*</span></label>
                <model-list-select :list="PaymentOptions ? PaymentOptions : []" v-model="totals.mode"
                  style="font-size: 15px;" option-value="id" option-text="mode" placeholder="Select Method"
                  @input="resetErrors()">
                </model-list-select>
              </div>
              <div class="text-danger" v-if="modeError">
                <em>{{ modeError }}</em>
              </div>
              <div class="form-group mb-2" v-if="GeneralSettings.sale_discount == 1">
                <label style="font-size: 20px;">Enter Discount</label>
                <input type="text" style="font-size: 15px;" class="form-control" v-model="totals.discount"
                  @input="discountCommas(), resetErrors(), showBalance()" min="0" />
              </div>
              <div class="form-group mb-2" v-if="GeneralSettings.back_date_sales == 1">
                <label style="font-size: 20px;"> Select Date <span class="text-danger">*</span></label>
                <input type="date" style="font-size: 15px;" class="form-control" v-model="totals.sale_date"
                  v-limit-future-date @input="resetErrors()" />
              </div>
              <div class="form-group mb-2" v-if="GeneralSettings.track_customers == 1">
                <label style="font-size: 20px;">Select Customer <span class="text-danger">*</span>
                  <span v-if="MyUserPerm.add_customers == 1">
                    <b-button size="sm" variant="link" v-b-modal.add-customer-modal>
                      <i class="fa fa-plus"></i> New Customer
                    </b-button>
                  </span>
                </label>
                <model-list-select :list="Customers ? Customers : []" v-model="totals.customer" option-value="id"
                  option-text="name1" placeholder="Select Customer" @input="resetErrors(), CheckBalance()"
                  @keyup.enter="saveSale()">
                </model-list-select>
              </div>
              <div class="text-danger" v-if="customerError">
                <em>{{ customerError }}</em>
              </div>
              <div class="form-group mb-2" v-if="GeneralSettings.multiple_factories == 1">
                <label style="font-size: 20px;">
                  Select Factory
                  <b-button size="sm" variant="link" v-b-modal.add-factory-modal>
                    <i class="fa fa-plus"></i> New Factory
                  </b-button>
                </label>
                <model-list-select :list="formattedFactories" v-model="totals.factory" option-value="id"
                  option-text="display_name" @input="FetchProductionBatches()" placeholder="Select Factory">
                </model-list-select>
              </div>
              <div class="form-group mb-2"
                v-if="GeneralSettings.attach_production_batch_on_sales == 1 && MyUserPerm.attach_production_batch_on_sales">
                <label style="font-size: 20px;">Select Production Batch</label>
                <model-list-select :list="formattedProductionBatches" v-model="totals.batch" option-value="id"
                  option-text="display_name" placeholder="Select Production Batch">
                </model-list-select>
              </div>
              <div class="text-danger" v-if="staffError">
                <em>{{ staffError }}</em>
              </div>
              <div class="form-group mb-2" v-if="GeneralSettings.capture_delivery_staff == 1">
                <label style="font-size: 20px;">Select Attending Staff</label>
                <model-list-select :list="DeliveryStaff ? DeliveryStaff : []" v-model="totals.staff" option-value="id"
                  option-text="name" placeholder="Select Staff" @input="resetErrors()" @keyup.enter="saveSale()">
                </model-list-select>
              </div>
              <div class="text-danger" v-if="staffError">
                <em>{{ staffError }}</em>
              </div>
              <div class="form-group mb-2" v-if="GeneralSettings.sale_pickingdate == 1">
                <label style="font-size: 20px;">Picking Date</label>
                <input style="font-size: 20px;" type="date" class="form-control" v-model="totals.picking_date" />
              </div>
              <div class="bg-light rounded p-3 mt-3 border" v-if="MyUserPerm.new_sale == 1">
                <div class="row g-3 text-center">

                  <!-- PRINT RECEIPT -->
                  <div class="col-12 col-md" v-if="ReceiptSettings.print_receipt_after_sale == 1">
                    <b-button block variant="primary" class="w-100" :disabled="SaleSaveStatus"
                      @click="saveSalePrint(1)">
                      <b-spinner v-if="SaleSaveStatus" small variant="light" class="mr-1"></b-spinner>
                      <i v-else class="fa fa-print mr-1"></i>
                      Print Receipt
                    </b-button>
                  </div>

                  <!-- PRINT INVOICE -->
                  <div class="col-12 col-md" v-if="ReceiptSettings.print_receipt_after_sale == 1">
                    <b-button block variant="primary" class="w-100" :disabled="SaleSaveStatus"
                      @click="saveSalePrint(2)">
                      <b-spinner v-if="SaleSaveStatus" small variant="light" class="mr-1"></b-spinner>
                      <i v-else class="fa fa-file-text mr-1"></i>
                      Print Invoice
                    </b-button>
                  </div>

                  <!-- DELIVERY NOTE -->
                  <div class="col-12 col-md" v-if="ReceiptSettings.print_receipt_after_sale == 1">
                    <b-button block variant="primary" class="w-100" :disabled="SaleSaveStatus"
                      @click="saveSalePrint(3)">
                      <b-spinner v-if="SaleSaveStatus" small variant="light" class="mr-1"></b-spinner>
                      <i v-else class="fa fa-truck mr-1"></i>
                      Delivery Note
                    </b-button>
                  </div>

                  <!-- SAVE -->
                  <div class="col-12 col-md">
                    <b-button block variant="success" class="w-100" :disabled="SaleSaveStatus" @click="saveSaleExit()">
                      <b-spinner v-if="SaleSaveStatus" small variant="light" class="mr-1"></b-spinner>
                      <i v-else class="fa fa-check mr-1"></i>
                      Save
                    </b-button>
                  </div>

                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Customer modal starts -->
    <b-modal id="add-customer-modal" hide-footer @hidden="resetCustomer">
      <template #modal-title> Add Customer </template>

      <div class="form-group mb-3">
        <label>Customer Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input type="text" placeholder="Enter Name " class="form-control" @input="resetErrors()"
            v-model="customerdata.name" />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Customer Contact</label>
        <div class="input-group">
          <input type="number" placeholder="Enter Phone Number" class="form-control" v-model="customerdata.contact"
            @input="resetErrors()" />
        </div>
        <div class="text-danger" v-if="contactError">
          <em>{{ contactError }}</em>
        </div>
      </div>

      <div class="form-group" v-if="BusinessSettings.agent_section == 1">
        <label>Select Outlet <span class="text-danger">*</span></label>
        <model-list-select :list="RetailOutlets ? RetailOutlets : []" v-model="customerdata.category_id"
          option-value="id" option-text="name" placeholder="Select Outlet">
        </model-list-select>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="closeModal('add-customer-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-primary"> <i class="fa fa-check"></i>
          Submit
          <b-spinner disabled variant="light" small label="Spinning"></b-spinner>
        </button>
        <button v-else type="button" class="btn btn-primary" @click="addCustomer('add-customer-modal')"> <i
            class="fa fa-check"></i>
          Submit
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal edit item starts -->
    <b-modal id="edit-item-modal" class="text-primary" hide-footer @hidden="resetEdit()">
      <template #modal-title>
        Edit Item {{ editdata.name }}</template>
      <div class="form-group mb-3">
        <label>Quantity</label>
        <input type="number" class="form-control" step="any" v-model="editdata.quantity"
          @input="resetErrors(), validateQty1()" />
        <div class="text-danger" v-if="quantity1Error">
          <em>{{ quantity1Error }}</em>
        </div>
      </div>
      <div class="form-group mb-3" v-if="GeneralSettings.track_untake_orders == 1">
        <label>Quantity taken</label>
        <input type="number" class="form-control" step="any" v-model="editdata.quantity_taken" />
      </div>
      <div class="form-group mb-3" v-if="MyUserPerm.edit_selling_price == 1">
        <label>Unit Price</label>
        <input type="text" class="form-control" step="any" v-model="editdata.unit_price" @input="editBuyingCommas()" />
        <div class="text-danger" v-if="unit_priceError">
          <em>{{ unit_priceError }}</em>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="closeModal('edit-item-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-primary" @click="editItem('edit-item-modal')">
          <i class="fa fa-check"></i> Save Changes
          <b-spinner v-if="SaleSaveStatus" variant="light" small label="Deleting"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete expense starts -->
    <b-modal id="delete-item-modal" class="text-danger" hide-footer @hidden="resetDeleteItem">
      <template #modal-title> Delete {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>Do you want to remove this item? Click Proceed to continue.</h5>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal('delete-item-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button type="button" class="btn btn-danger" @click="deleteItem('delete-item-modal')">
          <i class="fa fa-trash"></i> Proceed
          <b-spinner v-if="SaleSaveStatus" variant="light" small label="Deleting"></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- Factory modal starts -->
    <b-modal id="add-factory-modal" hide-footer @hidden="resetFactory">
      <template #modal-title> Add Factory </template>

      <div class="form-group mb-3">
        <label>Factory Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input type="text" placeholder="Enter Name " class="form-control" @input="resetErrors()"
            v-model="factorydata.name" />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Factory Contact</label>
        <div class="input-group">
          <input type="number" placeholder="Enter Factory Contact" class="form-control" v-model="factorydata.contact"
            @input="resetErrors()" />
        </div>
        <div class="text-danger" v-if="contactError">
          <em>{{ contactError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Factory Location</label>
        <div class="input-group">
          <input type="text" placeholder="Enter Factory Location" class="form-control" v-model="factorydata.location" />
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="closeModal('add-factory-modal')">
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-primary"> <i class="fa fa-check"></i>
          Submit
          <b-spinner disabled variant="light" small label="Spinning"></b-spinner>
        </button>
        <button v-else type="button" class="btn btn-primary" @click="addFactory('add-factory-modal')"> <i
            class="fa fa-check"></i>
          Submit
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

  </Layout>
</template>
<style>
.btn-primary,
.page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}

/* ===== SALES HEADER ===== */
.sales-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  background: #fff;
  padding: 10px 20px;
  border-bottom: 1px solid #e5e7eb;

  position: sticky;
  top: 0;
  z-index: 50;
}

/* LEFT */
.left-section {
  display: flex;
  align-items: center;
}

/* BACK BUTTON */
.back-btn {
  background: #e612e6;
  color: #fff;
  padding: 6px 12px;
  border-radius: 8px;
  text-decoration: none;
  font-size: 14px;

  display: flex;
  align-items: center;
  gap: 6px;
}

.back-btn:hover {
  background: #c010c0;
  color: #fff;
}

/* CENTER */
.center-section {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  text-align: center;
  max-width: 60%;
  line-height: 1.2;
}

/* TITLE */
.title-main {
  font-size: 18px;
  font-weight: 800;
  color: #e612e6;
}

.title-sub {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

/* RIGHT */
.right-section {
  display: flex;
  align-items: center;
}

/* USER */
.user-toggle {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
}

.user-box {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

/* AVATAR */
.avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 2px solid #e612e6;
}

/* USERNAME */
.username {
  font-weight: 600;
  font-size: 14px;
  color: #111827;
}

/* DROPDOWN */
.dropdown-modern {
  border-radius: 10px;
  border: none;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.logout {
  color: #ef4444 !important;
}
</style>